<script>
import Layout from "../../layouts/main";
import UI from "../../../components/components/UI.vue";
import Documents from "../documents/index.vue";
import { ui } from "./data";
import * as pageService from "../../../components/service/page.service";
import * as categoryService from "../../../components/service/category.service";
import * as practiceService from "../../../components/service/practice.service";
import * as cmsService from "../../../components/service/cms.service";
import Swal from "sweetalert2";
import store from "../../../state/store";
import { v4 as uuidv4 } from "uuid";
import _ from "lodash";
import AWS from "aws-sdk";
import api from "../../../api";

function sleep(seconds) {
  return new Promise((resolve) => setTimeout(resolve, seconds * 1000));
}

Array.prototype.move = function (from, to) {
  this.splice(to, 0, this.splice(from, 1)[0]);
};

export default {
  components: {
    UI,
    Layout,
    Documents,
  },
  computed: {
    ui() {
      return ui[this.$route.params.categoryName];
    },
  },
  data() {
    return {
      topbarControls: {
        config: {},
        fn: null,
        onDelFn: null,
        service: null,
      },
    };
  },
  methods: {
    replaceStringsFromArrayWithDashes(originalString, stringsToReplace) {
      let modifiedString = originalString;

      stringsToReplace.forEach((str) => {
        const escapedStr = str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // Escape special characters
        const replacement = "-".repeat(str.length);
        modifiedString = modifiedString.replace(
          new RegExp(escapedStr, "g"),
          replacement
        );
      });

      return modifiedString;
    },
    updtaeAdditionPropValue(dataObject) {
      Object.keys(dataObject.additionalProp1).forEach((key) => {
        if (_.has(dataObject, key)) {
          dataObject.additionalProp1[key] = dataObject[key];
        }
      });
      return dataObject;
    },
    setSelectedItems(val) {
      this.setTopbarControls(null, null, val, JSON.stringify(val), null);
    },
    updateSelectedItem(val) {
      this.selectedItem = val;
    },
    setListItems(val, sort) {
      if (sort)
        this.topbarControls.listItems = val.sort(
          (a, b) => a.additionalProp1.position - b.additionalProp1.position
        );
      else this.topbarControls.listItems = val;
      if (this.topbarControls.listItems.length)
        this.setSelectedItems(this.topbarControls.listItems[0]);
      else this.setSelectedItems({});
      if (!this.topbarControls.listItems.length)
        this.topbarControls.listItems = [];
      this.setTopbarControls(
        null,
        this.topbarControls.listItems,
        null,
        null,
        null
      );
    },
    updateDeletedItemList(val, sort) {
      let itemExists = false;
      if (val)
        itemExists = this.topbarControls.listItems.find((x) => x.id == val);
      if (itemExists) {
        let updatedList = this.topbarControls.listItems.filter(
          (x) => x.id != val
        );
        this.setListItems(updatedList, sort);
      }
    },
    createdItem(val) {
      const oldList = this.topbarControls.listItems;
      if (
        this.$route.params.categoryName == "practiceteam" ||
        this.$route.params.categoryName == "nonnhsfees" ||
        this.$route.params.categoryName == "pcnteam" ||
        this.$route.params.categoryName == "clinics&services" ||
        this.$route.params.categoryName == "jointhepracticeicb" ||
        this.$route.params.categoryName == "prescriptionsicb" ||
        this.$route.params.categoryName == "sick/fitnotesicb" ||
        this.$route.params.categoryName == "carerinformationicb" ||
        this.$route.params.categoryName == "patientgroupicb" ||
        this.$route.params.categoryName == "jointhepractice" ||
        this.$route.params.categoryName == "prescriptions" ||
        this.$route.params.categoryName == "cancelappointments" ||
        this.$route.params.categoryName == "bookappointments" ||
        this.$route.params.categoryName == "sick/fitnotes" ||
        this.$route.params.categoryName == "carerinformation" ||
        this.$route.params.categoryName == "patientgroup" ||
        this.$route.params.categoryName == "landingpage" ||
        this.$route.params.categoryName == "receptionenquiries" ||
        this.$route.params.categoryName == "practicepolicies" ||
        this.$route.params.categoryName == "managecondition" ||
        this.$route.params.categoryName == "aboutus" ||
        this.$route.params.categoryName == "health&wellbeing" ||
        this.$route.params.categoryName == "pcninfo."
      ) {
        this.topbarControls.listItems.push(val);
      } else {
        this.topbarControls.listItems.unshift(val);
      }
      this.setTopbarControls(
        null,
        this.topbarControls.listItems,
        null,
        null,
        null
      );
      this.setSelectedItems(val);
      this.updateListPositions(oldList, this.topbarControls.listItems);
    },
    createdCategory(val) {
      this.listItems.push(val);
      this.setSelectedItems(val);
    },
    isObject(object) {
      return object != null && typeof object === "object";
    },
    isItemEqual(previous, current) {
      // need to remove this code.
      for (const [p_key, p_val] of Object.entries(previous)) {
        if (p_key == "icon") {
          if (previous[p_key].title != current[p_key].title) {
            return false;
          }
        } else if (p_key === "layout") {
          if (previous[p_key].name != current[p_key].name) {
            return false;
          }
        }
        if (!this.isObject(current[p_key]) && current[p_key] != p_val) {
          // For debugging
          // console.log(`Key: ${p_key} | Prev: ${p_val} - Curr: ${current[p_key]}`)
          return false;
        }
      }
      return true;
    },
    updateListPositions(oldList, list) {
      list.forEach(async (item, index) => {
        const fromIndex = oldList.findIndex(
          (arrItem) => arrItem.id === item.id
        );
        oldList.move(fromIndex, index);
        item.additionalProp1.position = index;
        try {
          let data = {
            additionalProp1: item.additionalProp1,
          };
          await pageService.patch(item.id, data);
        } catch (err) {
          console.log(err);
        }
      });
      this.setTopbarControls(null, list, null, null, null);
    },
    getDifference(array1, array2) {
      return array1.filter((object1) => {
        return !array2.some((object2) => {
          return object1.id === object2.id;
        });
      });
    },

    async createBanners(id, title, parentId, web, tablet, mobile) {
      let filter = {
        include: [
          {
            relation: "practiceData",
            scope: {
              include: [
                {
                  relation: "cms",
                  scope: {
                    include: [
                      {
                        relation: "categories",
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      };
      try {
        filter = encodeURIComponent(JSON.stringify(filter));
        const data = await practiceService.getWithFilterWithId(id, filter);

        const banners = data.practiceData.cms.categories.find(
          (x) => x.name == "Banners"
        );
        const cmsId = data.practiceData.cms.id;

        if (banners && banners.id) {
          let body = {
            uuid: uuidv4(),
            url: "",
            active: false,
            title: title,
            picture: "",
            excerpt: "NA",
            description: "",
            deleted: false,
            creationDate: "2023-03-09T19:28:31.540Z",
            lastModifiedDate: "2023-03-09T19:28:31.540Z",
            categoryId: banners.id,
            cmsId: cmsId,
            parentId: parentId,
            additionalProp1: {
              web: web,
              tablet: tablet,
              mobile: mobile,
            },
          };

          await categoryService.postPages(banners.id, body);
        }
      } catch (e) {
        console.log(e);
      }
    },

    async removeBanners(id, parentId) {
      let filter = {
        include: [
          {
            relation: "practiceData",
            scope: {
              include: [
                {
                  relation: "cms",
                  scope: {
                    include: [
                      {
                        relation: "categories",
                        scope: {
                          where: {
                            name: "Banners",
                          },
                          include: [
                            {
                              relation: "pages",
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      };
      try {
        filter = encodeURIComponent(JSON.stringify(filter));
        const data = await practiceService.getWithFilterWithId(id, filter);

        const banners = data.practiceData.cms.categories.find(
          (x) => x.name == "Banners"
        );
        if (banners && banners.pages && banners.pages.length) {
          const removablePage = banners.pages.find(
            (x) => x.parentId == parentId
          );
          if (removablePage) await pageService.del(removablePage.id);
        }
      } catch (e) {
        console.log(e);
      }
    },

    async createFaq(name, id, title, parentId, answer) {
      let filter = {
        include: [
          {
            relation: "practiceData",
            scope: {
              include: [
                {
                  relation: "cms",
                  scope: {
                    include: [
                      {
                        relation: "categories",
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      };
      try {
        filter = encodeURIComponent(JSON.stringify(filter));
        const data = await practiceService.getWithFilterWithId(id, filter);

        const joinThePractice = data.practiceData.cms.categories.find(
          (x) => x.name == name
        );
        const cmsId = data.practiceData.cms.id;

        if (joinThePractice && joinThePractice.id) {
          let body = {
            uuid: uuidv4(),
            url: "",
            active: false,
            title: title,
            picture: "",
            excerpt: "NA",
            description: "",
            deleted: false,
            creationDate: "2023-03-09T19:28:31.540Z",
            lastModifiedDate: "2023-03-09T19:28:31.540Z",
            categoryId: joinThePractice.id,
            cmsId: cmsId,
            parentId: parentId,
            additionalProp1: {
              answer: answer,
            },
          };

          await categoryService.postPages(joinThePractice.id, body);
        }
      } catch (e) {
        console.log(e);
      }
    },

    async removeFaq(name, id, parentId) {
      let filter = {
        include: [
          {
            relation: "practiceData",
            scope: {
              include: [
                {
                  relation: "cms",
                  scope: {
                    include: [
                      {
                        relation: "categories",
                        scope: {
                          where: {
                            name: name,
                          },
                          include: [
                            {
                              relation: "pages",
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      };
      try {
        filter = encodeURIComponent(JSON.stringify(filter));
        const data = await practiceService.getWithFilterWithId(id, filter);

        const joinThePractice = data.practiceData.cms.categories.find(
          (x) => x.name == name
        );
        if (
          joinThePractice &&
          joinThePractice.pages &&
          joinThePractice.pages.length
        ) {
          const removablePage = joinThePractice.pages.find(
            (x) => x.parentId == parentId
          );
          if (removablePage) await pageService.del(removablePage.id);
        }
      } catch (e) {
        console.log(e);
      }
    },

    async updateFaq(name, parentId, title, answer) {
      let filter = {
        where: {
          name: name,
        },
        include: [
          {
            relation: "pages",
          },
        ],
      };
      try {
        filter = encodeURIComponent(JSON.stringify(filter));
        const data = await categoryService.getWithFilter(filter);

        let pages = [];

        for (const cat of data) {
          let tempPages = cat.pages.filter((x) => x.parentId == parentId);
          pages = [...pages, ...tempPages];
        }

        for (const page of pages) {
          let additionalProp1 = page.additionalProp1;
          Object.assign(additionalProp1, { answer: answer });

          let body = {
            title: title,
            additionalProp1: additionalProp1,
          };

          await pageService.patch(page.id, body);
        }
      } catch (e) {
        console.log(e);
      }
    },

    async getHTtokenDetails() {
      let url = `/api/analytics-results/gethttokendetails`;

      try {
        const data = await api.get(url);
        return data;
      } catch (error) {
        console.error("Error fetching FFT results", error);
      }
    },

    async updatePatientNews(cmsId, data) {
      let filter = {
        where: {
          name: "News",
        },
      };
      try {
        filter = encodeURIComponent(JSON.stringify(filter));
        const category = await cmsService.getCategoriesWithFilter(
          cmsId,
          filter
        );
        if (category && category.length) {
          let additionalProp1 = category[0].additionalProp1;
          Object.assign(additionalProp1, {
            facebook: data.additionalProp1.facebook_patientnews,
          });
          Object.assign(additionalProp1, {
            twitter: data.additionalProp1.twitter_patientnews,
          });
          await categoryService.patch(category[0].id, {
            additionalProp1: additionalProp1,
          });
        }
      } catch (e) {
        console.log(e);
      }
    },

    async updateSocialMedia(cmsId, data) {
      let filter = {
        where: {
          name: "Social Media",
        },
      };
      try {
        filter = encodeURIComponent(JSON.stringify(filter));
        const category = await cmsService.getCategoriesWithFilter(
          cmsId,
          filter
        );
        if (category && category.length) {
          let additionalProp1 = category[0].additionalProp1;
          Object.assign(additionalProp1, {
            facebook_patientnews: data.additionalProp1.facebook,
          });
          Object.assign(additionalProp1, {
            twitter_patientnews: data.additionalProp1.twitter,
          });
          await categoryService.patch(category[0].id, {
            additionalProp1: additionalProp1,
          });
        }
      } catch (e) {
        console.log(e);
      }
    },

    async timer() {
      let timerInterval;
      Swal.fire({
        title: "Updating Category",
        html: "Please wait while we update category.",
        timer: 6000,
        timerProgressBar: true,
        showCancelButton: false,
        showConfirmButton: false,
        onBeforeOpen: () => {
          Swal.showLoading();
        },
        onClose: () => {
          clearInterval(timerInterval);
        },
      }).then((result) => {
        if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.timer
        ) {
          console.log("I was closed by the timer"); // eslint-disable-line
        }
      });
    },

    async setTopbarControls(
      self,
      listItems,
      selectedItem,
      prevSelectedItem,
      category
    ) {
      if (self) {
        this.topbarControls.config = self.topbarControls;
        this.topbarControls.service = self.service;
        this.topbarControls.title = self.title;
      }

      if (listItems) this.topbarControls.listItems = listItems;
      if (selectedItem) this.topbarControls.selectedItem = selectedItem;
      if (prevSelectedItem)
        this.topbarControls.prevSelectedItem = prevSelectedItem;
      if (category) this.topbarControls.category = category;

      var thisScope = this;
      switch (this.topbarControls.service) {
        case "pages": {
          const addFn = async function (val) {
            console.log("add funtion called", val);
            var data = {
              uuid: uuidv4(),
              url:
                thisScope.$route.params.categoryName == "patientnews" ||
                thisScope.$route.params.categoryName == "globalupdate"
                  ? val.title.toLowerCase().replace(" ", "-")
                  : store.getters.currentPractice.additionalProp1.url,
              active:
                thisScope.$route.params.categoryName == "alerts" ||
                thisScope.$route.params.categoryName == "globalupdate"
                  ? false
                  : true,
              title: "",
              picture: "",
              excerpt: "NA",
              description: "",
              deleted: false,
              creationDate: new Date().toISOString(),
              lastModifiedDate: new Date().toISOString(),
              cmsId: thisScope.$route.params.cmsId,
              pcnId: store.getters.currentPracticeData.pcnId,
              additionalProp1: {
                dynamoId: store.getters.currentPractice.additionalProp1.dynamo,
              },
            };
            if (
              thisScope.$route.params.categoryName == "patientnews" ||
              thisScope.$route.params.categoryName == "globalupdate"
            ) {
              Object.assign(data, { featured: false });
              Object.assign(data, { media_type: "None" });
            }
            if (thisScope.$route.params.categoryName == "footer") {
              Object.assign(data, { link_type: "External Link" });
            }
            if (
              thisScope.$route.params.categoryName == "contactus" ||
              thisScope.$route.params.categoryName == "commonconditions" ||
              thisScope.$route.params.categoryName == "quicklinks"
            ) {
              Object.assign(data, { label: val.title });
            }
            if (thisScope.$route.params.categoryName == "globalupdate") {
              Object.assign(data, {
                further_details: { name: "External Link" },
              });
            }
            if (thisScope.$route.params.categoryName == "alerts") {
              Object.assign(data, {
                further_details: { name: "Expand" },
              });
            }
            Object.assign(
              data.additionalProp1,
              thisScope.topbarControls.config.addNewModal.additionalProps
            );
            if (val.location_id) {
              Object.assign(data.additionalProp1, {
                location_id: val.location_id.id,
              });
            }
            if (val.group) {
              Object.assign(data.additionalProp1, { group: val.group });
            }
            Object.assign(data, val);
            if (
              thisScope.$route.params.categoryName == "practiceteam" ||
              thisScope.$route.params.categoryName == "nonnhsfees" ||
              thisScope.$route.params.categoryName == "receptionenquiries"
            ) {
              if (!data.title.length || !data.group.length) {
                Swal.fire(
                  thisScope.topbarControls.config.addNewErrorTitle,
                  thisScope.topbarControls.config.addNewErrorMessage,
                  "error"
                );
                return;
              }
            }
            try {
              let result = await categoryService.postPages(
                thisScope.$route.params.categoryId,
                data
              );
              thisScope.createdItem(result);
              Swal.fire(
                thisScope.topbarControls.config.addNewSuccessTitle,
                thisScope.topbarControls.config.addNewSuccessMessage,
                "success"
              );
            } catch (err) {
              Swal.fire(
                thisScope.topbarControls.config.addNewErrorTitle,
                thisScope.topbarControls.config.addNewErrorMessage,
                "error"
              );
              console.log(err);
            }
          };
          const deleteFn = function () {
            let item = thisScope.topbarControls.selectedItem;

            if (
              item.parentId &&
              (thisScope.$route.params.categoryName == "jointhepractice" ||
                thisScope.$route.params.categoryName == "prescriptions" ||
                thisScope.$route.params.categoryName == "cancelappointments" ||
                thisScope.$route.params.categoryName == "bookappointments" ||
                thisScope.$route.params.categoryName == "sick/fitnotes" ||
                thisScope.$route.params.categoryName == "carerinformation" ||
                thisScope.$route.params.categoryName == "patientgroup")
            ) {
              Swal.fire(
                "Access Denied",
                "You don't have access to delete this item. Please contact your ICB.",
                "error"
              );
              return;
            }

            Swal.fire({
              title: `Are you sure you want to delete ${item.title}?`,
              text: "You won't be able to revert this!",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: "Yes, delete it!",
            }).then(async (result) => {
              if (result.value) {
                try {
                  if (
                    thisScope.$route.params.categoryName == "jointhepracticeicb"
                  ) {
                    thisScope.timer();
                    const prevData = await pageService.get(item.id);
                    await sleep(5);
                    const prevPractices =
                      prevData.practices && prevData.practices.valuePractices
                        ? prevData.practices.valuePractices
                        : [];
                    for (const practice of prevPractices) {
                      await thisScope.removeFaq(
                        "Join the Practice",
                        practice.id,
                        item.id
                      );
                    }
                  } else if (
                    thisScope.$route.params.categoryName == "prescriptionsicb"
                  ) {
                    thisScope.timer();
                    const prevData = await pageService.get(item.id);
                    await sleep(5);
                    const prevPractices =
                      prevData.practices && prevData.practices.valuePractices
                        ? prevData.practices.valuePractices
                        : [];
                    for (const practice of prevPractices) {
                      await thisScope.removeFaq(
                        "Prescriptions",
                        practice.id,
                        item.id
                      );
                    }
                  } else if (
                    thisScope.$route.params.categoryName == "sick/fitnotesicb"
                  ) {
                    thisScope.timer();
                    const prevData = await pageService.get(item.id);
                    await sleep(5);
                    const prevPractices =
                      prevData.practices && prevData.practices.valuePractices
                        ? prevData.practices.valuePractices
                        : [];
                    for (const practice of prevPractices) {
                      await thisScope.removeFaq(
                        "Sick/Fit Notes",
                        practice.id,
                        item.id
                      );
                    }
                  } else if (
                    thisScope.$route.params.categoryName ==
                    "carerinformationicb"
                  ) {
                    thisScope.timer();
                    const prevData = await pageService.get(item.id);
                    await sleep(5);
                    const prevPractices =
                      prevData.practices && prevData.practices.valuePractices
                        ? prevData.practices.valuePractices
                        : [];
                    for (const practice of prevPractices) {
                      await thisScope.removeFaq(
                        "Carer Information",
                        practice.id,
                        item.id
                      );
                    }
                  } else if (
                    thisScope.$route.params.categoryName == "patientgroupicb"
                  ) {
                    thisScope.timer();
                    const prevData = await pageService.get(item.id);
                    await sleep(5);
                    const prevPractices =
                      prevData.practices && prevData.practices.valuePractices
                        ? prevData.practices.valuePractices
                        : [];
                    for (const practice of prevPractices) {
                      await thisScope.removeFaq(
                        "Patient Group",
                        practice.id,
                        item.id
                      );
                    }
                  }

                  await pageService.del(item.id);
                  Swal.fire(
                    thisScope.topbarControls.config.deleteSuccessTitle,
                    thisScope.topbarControls.config.deleteSuccessMessage,
                    "success"
                  );
                  thisScope.updateDeletedItemList(item.id, true);
                } catch (err) {
                  Swal.fire(
                    thisScope.topbarControls.config.deleteErrorTitle,
                    thisScope.topbarControls.config.deleteErrorMessage,
                    "error"
                  );
                  console.log(err);
                }
              }
            });
          };
          const activeFn = async function (val) {
            if (val && thisScope.topbarControls.config.activeLimit) {
              let activeCount = thisScope.topbarControls.listItems.filter(
                (x) => x.active == true
              ).length;
              if (activeCount >= thisScope.topbarControls.config.activeLimit) {
                Swal.fire(
                  thisScope.topbarControls.config.activeErrorTitle,
                  thisScope.topbarControls.config.activeErrorMessage,
                  "error"
                );
                return;
              }
            }
            try {
              // if(thisScope.$route.params.categoryName == 'banners'
              // || thisScope.$route.params.categoryName == 'jointhepractice'
              // || thisScope.$route.params.categoryName == 'prescriptions'
              // || thisScope.$route.params.categoryName == 'sick/fitnotes'
              // || thisScope.$route.params.categoryName == 'carerinformation'
              // || thisScope.$route.params.categoryName == 'patientgroup'
              // ) {
              //   thisScope.timer()
              //   const icbBanner = await pageService.get(thisScope.topbarControls.selectedItem.parentId)
              //   const valuePractices = icbBanner.practices.valuePractices
              //   let myPractice = valuePractices.find(x => x.id == thisScope.currentPractice.id)

              //   const itemIndex = valuePractices.findIndex(o => o.id === myPractice.id);
              //   Object.assign(myPractice, {using: val})
              //   valuePractices[itemIndex] = myPractice

              //   const practices = icbBanner.practices
              //   practices.valuePractices = valuePractices

              //   await sleep(5)
              //   await pageService.patch(thisScope.topbarControls.selectedItem.parentId, {practices: practices})
              // }

              let data = { active: val };
              await pageService.patch(
                thisScope.topbarControls.selectedItem.id,
                data
              );
              const item = thisScope.topbarControls.selectedItem;
              Object.assign(item, data);
              thisScope.setSelectedItems(item);
              if (val) {
                Swal.fire(
                  thisScope.topbarControls.config.activeSuccessTitle,
                  thisScope.topbarControls.config.activeSuccessMessage,
                  "success"
                );
              } else {
                Swal.fire(
                  "Topic Inactivated!",
                  "Topic Inactivated Successfully! ",
                  "success"
                );
              }
            } catch (err) {
              Swal.fire(
                thisScope.topbarControls.config.activeErrorTitle,
                thisScope.topbarControls.config.activeErrorMessage,
                "error"
              );
              console.log(err);
            }
          };
          const activeGlobalFn = async function (val) {
            try {
              let practices = thisScope.topbarControls.selectedItem.practices;
              practices.find(
                (x) => x.practice_id == thisScope.currentPractice.id
              ).active = val;
              let data = { practices: practices };
              await pageService.patch(
                thisScope.topbarControls.selectedItem.id,
                data
              );
              const item = thisScope.topbarControls.selectedItem;
              Object.assign(item, data);
              thisScope.setSelectedItems(item);
              if (val) {
                Swal.fire(
                  thisScope.topbarControls.config.activeSuccessTitle,
                  thisScope.topbarControls.config.activeSuccessMessage,
                  "success"
                );
              } else {
                Swal.fire(
                  "Topic Inactivated!",
                  "Topic Inactivated Successfully! ",
                  "success"
                );
              }
            } catch (err) {
              Swal.fire(
                thisScope.topbarControls.config.activeErrorTitle,
                thisScope.topbarControls.config.activeErrorMessage,
                "error"
              );
              console.log(err);
            }
          };
          const dragUpdateFn = async function (oldList, list) {
            thisScope.updateListPositions(oldList, list);
          };
          const switchItemFn = async function (val) {
            console.log("change4");

            const prev = JSON.parse(thisScope.topbarControls.prevSelectedItem);
            const curr = thisScope.topbarControls.selectedItem;

            if (thisScope.isItemEqual(prev, curr)) {
              thisScope.setTopbarControls(
                null,
                null,
                val,
                JSON.stringify(val),
                null
              );
            } else {
              const { isConfirmed } = await Swal.fire({
                title: "You have unsaved changes.",
                text: "Please save your changes before switching to next topic.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Discard changes",
              });
              if (isConfirmed) {
                let indx = thisScope.topbarControls.listItems.findIndex(
                  (x) => x.id == prev.id
                );
                for (const key of Object.keys(
                  thisScope.topbarControls.listItems[indx]
                )) {
                  thisScope.topbarControls.listItems[indx][key] = prev[key];
                }
                thisScope.setTopbarControls(
                  null,
                  null,
                  val,
                  JSON.stringify(val),
                  null
                );
              }
            }
          };
          const submitFn = async function (val) {
            // thisScope.customValidation(val);
            if (
              thisScope.$route.params.categoryName == "patientvoice" &&
              val?.chat
            ) {
              val.chat.forEach((rt) => {
                if (rt.strickMessage) {
                  rt.text = thisScope.replaceStringsFromArrayWithDashes(
                    rt.text,
                    rt.strickMessage
                  );
                  rt.strickMessage = [];
                }
              });
            }

            if (
              val.parentId &&
              (thisScope.$route.params.categoryName == "jointhepractice" ||
                thisScope.$route.params.categoryName == "prescriptions" ||
                thisScope.$route.params.categoryName == "cancelappointments" ||
                thisScope.$route.params.categoryName == "bookappointments" ||
                thisScope.$route.params.categoryName == "sick/fitnotes" ||
                thisScope.$route.params.categoryName == "carerinformation" ||
                thisScope.$route.params.categoryName == "patientgroup")
            ) {
              Swal.fire(
                "Access Denied",
                "You don't have access to update this item. Please contact your ICB.",
                "error"
              );
              return;
            }

            var data = JSON.stringify(val);
            data = JSON.parse(data);

            // Define fields that should only exist in additionalProp1 for specific categories
            const memberPracticesFields = [
              "practice_image",
              "website_url",
              "call_the_practice_toggle",
              "phone_number",
              "address",
              "position",
              "dynamoId",
              "picture",
            ];

            const pcnInsightsFields = [
              "total_appointments_booked",
              "total_dna",
              "total_telephone_appointments",
              "total_in_person_appointments",
              "period",
              "position",
              "dynamoId",
              "picture",
            ];

            const partnerOrganisationsFields = [
              "organisation_image",
              "website_url",
              "contact_organisation_toggle",
              "phone_number",
              "address",
              "position",
              "dynamoId",
              "picture",
            ];

            // For member practices, ensure proper field placement
            if (thisScope.$route.params.categoryName === "memberpractices") {
              memberPracticesFields.forEach((field) => {
                if (field in data && field !== "position") {
                  // Move root level fields to additionalProp1 and remove from root
                  if (!data.additionalProp1) data.additionalProp1 = {};
                  data.additionalProp1[field] = data[field];
                  delete data[field];
                }
              });
            } else if (thisScope.$route.params.categoryName === "pcninsights") {
              pcnInsightsFields.forEach((field) => {
                if (field in data && field !== "position") {
                  // Move root level fields to additionalProp1 and remove from root
                  if (!data.additionalProp1) data.additionalProp1 = {};
                  data.additionalProp1[field] = data[field];
                  delete data[field];
                }
              });
            } else if (thisScope.$route.params.categoryName === "partnerorganisations") {
              partnerOrganisationsFields.forEach((field) => {
                if (field in data && field !== "position") {
                  // Move root level fields to additionalProp1 and remove from root
                  if (!data.additionalProp1) data.additionalProp1 = {};
                  data.additionalProp1[field] = data[field];
                  delete data[field];
                }
              });
            } else {
              // Original logic for other categories
              for (const key of Object.keys(val)) {
                if (!(key in data)) {
                  data.additionalProp1[key] = val[key];
                  delete data[key];
                }
              }
            }
            if (data.slug && !data.slug.length) {
              var defaultSlug = data.title.replace(/\s/g, "").toLowerCase();
              Object.assign(data.additionalProp1, { slug: defaultSlug });
              delete data.slug;
            }
            if (val.group) {
              Object.assign(data.additionalProp1, { group: val.group });
              Object.assign(data.additionalProp1, { subgroup: "" });
              Object.assign(data.additionalProp1, {
                position: thisScope.topbarControls.listItems.length,
              });
            }
            if (val.subgroup) {
              Object.assign(data.additionalProp1, { subgroup: val.subgroup });
            }
            if (val.role || "role" in val) {
              Object.assign(data.additionalProp1, { role: val.role });
            }
            if (val.icon) {
              Object.assign(data.additionalProp1, { icon: val.icon });
            }
            if (val.date) {
              Object.assign(data.additionalProp1, { date: val.date });
            }
            if (val.gender) {
              Object.assign(data.additionalProp1, { gender: val.gender });
            }
            if (val.qualifications) {
              Object.assign(data.additionalProp1, {
                qualifications: val.qualifications,
              });
            }
            if (val.color) {
              Object.assign(data.additionalProp1, { color: val.color });
            }
            if (val.further_details) {
              Object.assign(data.additionalProp1, {
                further_details: val.further_details,
              });
            }
            if (val.news_item_id) {
              Object.assign(data.additionalProp1, {
                news_item_id: val.news_item_id,
              });
            }
            if (val.news_item_url) {
              Object.assign(data.additionalProp1, {
                news_item_url: val.news_item_url,
              });
            }
            if (val.status) {
              Object.assign(data.additionalProp1, { status: val.status });
            }
            if (val.reduced_hours) {
              Object.assign(data.additionalProp1, {
                reduced_hours: val.reduced_hours,
              });
            }
            if (val.opening_time) {
              Object.assign(data.additionalProp1, {
                opening_time: val.opening_time,
              });
            }
            if (val.closing_time) {
              Object.assign(data.additionalProp1, {
                closing_time: val.closing_time,
              });
            }
            if (val.second_opening_time) {
              Object.assign(data.additionalProp1, {
                second_opening_time: val.second_opening_time,
              });
            }
            if (val.second_closing_time) {
              Object.assign(data.additionalProp1, {
                second_closing_time: val.second_closing_time,
              });
            }
            if (
              val.locations &&
              thisScope.$route.params.categoryName != "pcnservices"
            ) {
              let outer_locations = val.locations;
              let inner_locations = data.additionalProp1.availability.locations;
              let new_locs = thisScope.getDifference(
                outer_locations,
                inner_locations
              );
              let rem_locs = thisScope.getDifference(
                inner_locations,
                outer_locations
              );

              inner_locations = inner_locations.filter(function (objFromA) {
                return !rem_locs.find(function (objFromB) {
                  return objFromA.id === objFromB.id;
                });
              });

              inner_locations = [...inner_locations, ...new_locs];
              val.locations = inner_locations;

              Object.assign(data.additionalProp1.availability, {
                locations: val.locations,
              });
            }
            if ("featured" in val) {
              Object.assign(data.additionalProp1, { featured: val.featured });
            }
            if ("media_type" in val) {
              Object.assign(data.additionalProp1, {
                media_type: val.media_type,
              });
            }
            if ("image_url" in val) {
              Object.assign(data.additionalProp1, { image_url: val.image_url });
            }
            if ("video_url" in val) {
              Object.assign(data.additionalProp1, { video_url: val.video_url });
            }
            try {
              let prevData;
              if (
                thisScope.$route.params.categoryName == "bannersicb" ||
                thisScope.$route.params.categoryName == "jointhepracticeicb" ||
                thisScope.$route.params.categoryName == "prescriptionsicb" ||
                thisScope.$route.params.categoryName == "sick/fitnotesicb" ||
                thisScope.$route.params.categoryName == "carerinformationicb" ||
                thisScope.$route.params.categoryName == "patientgroupicb"
              ) {
                thisScope.timer();
                prevData = await pageService.get(data.id);
                await sleep(5);
              }

              const computedData = data;
              Object.assign(computedData.additionalProp1, {
                position: val.additionalProp1.position,
              });
              if (
                thisScope.$route.params.categoryName === "infopages" ||
                thisScope.$route.params.categoryName === "banners"
              ) {
                await pageService.patch(
                  computedData.id,
                  thisScope.updtaeAdditionPropValue(computedData)
                );
              } else {
                await pageService.patch(computedData.id, computedData);
              }
              let temp_list = thisScope.topbarControls.listItems;
              const fromIndex = temp_list.findIndex(
                (arrItem) => arrItem.id === computedData.id
              );
              temp_list[fromIndex] = computedData;
              thisScope.setTopbarControls(null, temp_list, null, null, null);
              thisScope.setSelectedItems(val);

              if (
                thisScope.$route.params.categoryName == "bannersicb" ||
                thisScope.$route.params.categoryName == "jointhepracticeicb" ||
                thisScope.$route.params.categoryName == "prescriptionsicb" ||
                thisScope.$route.params.categoryName == "sick/fitnotesicb" ||
                thisScope.$route.params.categoryName == "carerinformationicb" ||
                thisScope.$route.params.categoryName == "patientgroupicb"
              ) {
                const prevPractices =
                  prevData.practices && prevData.practices.valuePractices
                    ? prevData.practices.valuePractices
                    : [];
                const newPractices =
                  computedData.practices &&
                  computedData.practices.valuePractices
                    ? computedData.practices.valuePractices
                    : [];

                const toBeAdded = newPractices.filter(
                  ({ id: id1 }) =>
                    !prevPractices.some(({ id: id2 }) => id2 === id1)
                );
                const toBeRemoved = prevPractices.filter(
                  ({ id: id1 }) =>
                    !newPractices.some(({ id: id2 }) => id2 === id1)
                );
                const remaining = newPractices.filter(({ id: id1 }) =>
                  prevPractices.some(({ id: id2 }) => id2 === id1)
                );

                if (thisScope.$route.params.categoryName == "bannersicb") {
                  for (const practice of toBeRemoved) {
                    await thisScope.removeBanners(practice.id, computedData.id);
                  }
                  for (const practice of toBeAdded) {
                    await thisScope.createBanners(
                      practice.id,
                      computedData.title,
                      computedData.id,
                      computedData.additionalProp1.web,
                      computedData.additionalProp1.tablet,
                      computedData.additionalProp1.mobile
                    );
                  }
                } else if (
                  thisScope.$route.params.categoryName == "jointhepracticeicb"
                ) {
                  if (remaining && remaining.length) {
                    let answer = computedData.answer ? computedData.answer : "";
                    await thisScope.updateFaq(
                      "Join the Practice",
                      computedData.id,
                      computedData.title,
                      answer
                    );
                  }
                  for (const practice of toBeRemoved) {
                    await thisScope.removeFaq(
                      "Join the Practice",
                      practice.id,
                      computedData.id
                    );
                  }
                  for (const practice of toBeAdded) {
                    let answer = computedData.answer ? computedData.answer : "";
                    await thisScope.createFaq(
                      "Join the Practice",
                      practice.id,
                      computedData.title,
                      computedData.id,
                      answer
                    );
                  }
                } else if (
                  thisScope.$route.params.categoryName == "prescriptionsicb"
                ) {
                  if (remaining && remaining.length) {
                    let answer = computedData.answer ? computedData.answer : "";
                    await thisScope.updateFaq(
                      "Prescriptions",
                      computedData.id,
                      computedData.title,
                      answer
                    );
                  }
                  for (const practice of toBeRemoved) {
                    await thisScope.removeFaq(
                      "Prescriptions",
                      practice.id,
                      computedData.id
                    );
                  }
                  for (const practice of toBeAdded) {
                    let answer = computedData.answer ? computedData.answer : "";
                    await thisScope.createFaq(
                      "Prescriptions",
                      practice.id,
                      computedData.title,
                      computedData.id,
                      answer
                    );
                  }
                } else if (
                  thisScope.$route.params.categoryName == "sick/fitnotesicb"
                ) {
                  if (remaining && remaining.length) {
                    let answer = computedData.answer ? computedData.answer : "";
                    await thisScope.updateFaq(
                      "Sick/Fit Notes",
                      computedData.id,
                      computedData.title,
                      answer
                    );
                  }
                  for (const practice of toBeRemoved) {
                    await thisScope.removeFaq(
                      "Sick/Fit Notes",
                      practice.id,
                      computedData.id
                    );
                  }
                  for (const practice of toBeAdded) {
                    let answer = computedData.answer ? computedData.answer : "";
                    await thisScope.createFaq(
                      "Sick/Fit Notes",
                      practice.id,
                      computedData.title,
                      computedData.id,
                      answer
                    );
                  }
                } else if (
                  thisScope.$route.params.categoryName == "carerinformationicb"
                ) {
                  if (remaining && remaining.length) {
                    let answer = computedData.answer ? computedData.answer : "";
                    await thisScope.updateFaq(
                      "Carer Information",
                      computedData.id,
                      computedData.title,
                      answer
                    );
                  }
                  for (const practice of toBeRemoved) {
                    await thisScope.removeFaq(
                      "Carer Information",
                      practice.id,
                      computedData.id
                    );
                  }
                  for (const practice of toBeAdded) {
                    let answer = computedData.answer ? computedData.answer : "";
                    await thisScope.createFaq(
                      "Carer Information",
                      practice.id,
                      computedData.title,
                      computedData.id,
                      answer
                    );
                  }
                } else if (
                  thisScope.$route.params.categoryName == "patientgroupicb"
                ) {
                  if (remaining && remaining.length) {
                    let answer = computedData.answer ? computedData.answer : "";
                    await thisScope.updateFaq(
                      "Patient Group",
                      computedData.id,
                      computedData.title,
                      answer
                    );
                  }
                  for (const practice of toBeRemoved) {
                    await thisScope.removeFaq(
                      "Patient Group",
                      practice.id,
                      computedData.id
                    );
                  }
                  for (const practice of toBeAdded) {
                    let answer = computedData.answer ? computedData.answer : "";
                    await thisScope.createFaq(
                      "Patient Group",
                      practice.id,
                      computedData.title,
                      computedData.id,
                      answer
                    );
                  }
                }
              }

              Swal.fire(
                thisScope.topbarControls.config.updateSuccessTitle,
                thisScope.topbarControls.config.updateSuccessMessage,
                "success"
              );
            } catch (err) {
              Swal.fire(
                thisScope.topbarControls.config.updateErrorTitle,
                thisScope.topbarControls.config.updateErrorMessage,
                "error"
              );
              console.log(err);
            }
          };
          this.topbarControls.onDelFn = deleteFn;
          this.topbarControls.onAddFn = addFn;
          this.topbarControls.onActiveFn = activeFn;
          this.topbarControls.onActiveGlobalFn = activeGlobalFn;
          this.topbarControls.onDragUpdateFn = dragUpdateFn;
          this.topbarControls.onSwitchItemFn = switchItemFn;
          this.topbarControls.onSubmitFn = submitFn;
          break;
        }
        case "category": {
          const submitFn = async function (val, form) {
            if (thisScope.topbarControls.title == "Healthier Together") {
              const tokenData = await thisScope.getHTtokenDetails();
              const config = {
                aws_table_name: "HT_Config",
                aws_remote_config: {
                  accessKeyId: tokenData?.data?.token ?? "",
                  secretAccessKey: tokenData?.data?.key ?? "",
                  region: "eu-west-2",
                },
              };

              AWS.config.update(config.aws_remote_config);
              const docClient = new AWS.DynamoDB.DocumentClient();

              const openingHours = val.days.map((x) => {
                return {
                  timings: x.timings,
                  day: x.day,
                  open: x.active,
                  ocTimings: `${x.start_time}-${x.end_time}`,
                };
              });
              let prevInfo = val.oldInfo ?? {};

              prevInfo.ocAgeMax = val.max_age ? parseInt(val.max_age) : 0;
              prevInfo.ocAgeMin = val.min_age ? parseInt(val.min_age) : 0;
              prevInfo.ocEmail = val.email ? val.email : "";
              prevInfo.ocEnabled = val.online_consultation ? true : false;
              prevInfo.ocEnabledChildren = val.online_consultation
                ? true
                : false;

              prevInfo.ocisSomethingElseCondition;
              prevInfo.isSomethingElseCondition = val.isSomethingElseCondition
                ? true
                : false;
              prevInfo.ocSuccessText = val.message ? val.message : "";
              prevInfo.openingHours = openingHours;

              const params = {
                TableName: config.aws_table_name,
                Key: {
                  nacsCode: val.nacsCode,
                },
                UpdateExpression: "set info = :info",
                ExpressionAttributeValues: {
                  ":info": prevInfo,
                },
              };

              docClient.update(params, async function (err) {
                if (err) {
                  Swal.fire(
                    thisScope.topbarControls.config.updateErrorTitle,
                    thisScope.topbarControls.config.updateErrorMessage,
                    "error"
                  );
                  console.log(err);
                } else {
                  let updatedCat = thisScope.currentCategory;
                  updatedCat.additionalProp1.days = val.days;
                  updatedCat.additionalProp1.message = val.message;
                  updatedCat.additionalProp1.email = val.email;
                  updatedCat.additionalProp1.max_age = val.max_age;
                  updatedCat.additionalProp1.min_age = val.min_age;
                  updatedCat.additionalProp1.online_consultation =
                    val.online_consultation;
                  await categoryService.patch(updatedCat.id, updatedCat);
                  Swal.fire(
                    thisScope.topbarControls.config.updateSuccessTitle,
                    thisScope.topbarControls.config.updateSuccessMessage,
                    "success"
                  );
                }
              });

              Swal.fire(
                thisScope.topbarControls.config.updateSuccessTitle,
                thisScope.topbarControls.config.updateSuccessMessage,
                "success"
              );
            } else {
              var data = JSON.stringify(val);

              for (const key of Object.keys(val)) {
                if (form[key] && form[key].inside) {
                  let inside = form[key].inside;
                  let temp = JSON.parse(data);
                  _.set(temp, inside, val[key]);
                  delete temp[key];
                  data = JSON.stringify(temp);
                } else {
                  let temp = JSON.parse(data);
                  if (key in temp.additionalProp1) {
                    temp.additionalProp1[key] = val[key];
                    delete temp[key];
                    data = JSON.stringify(temp);
                  }
                }
              }
              data = JSON.parse(data);
              try {
                if (thisScope.$route.params.categoryName == "socialmedia") {
                  thisScope.updatePatientNews(data.cmsId, data);
                } else if (
                  thisScope.$route.params.categoryName == "patientnews"
                ) {
                  thisScope.updateSocialMedia(data.cmsId, data);
                }

                await sleep(1);
                await categoryService.patch(data.id, data);
                thisScope.setSelectedItems(val);
                Swal.fire(
                  thisScope.topbarControls.config.updateSuccessTitle,
                  thisScope.topbarControls.config.updateSuccessMessage,
                  "success"
                );
              } catch (err) {
                Swal.fire(
                  thisScope.topbarControls.config.updateErrorTitle,
                  thisScope.topbarControls.config.updateErrorMessage,
                  "error"
                );
                console.log(err);
              }
            }
          };
          this.topbarControls.onSubmitFn = submitFn;
          break;
        }
        case "category2": {
          const submitFn = async function (val, form) {
            if (thisScope.topbarControls.title == "Healthier Together") {
              const tokenData = await thisScope.getHTtokenDetails();

              const config = {
                aws_table_name: "HT_Config",
                aws_remote_config: {
                  accessKeyId: tokenData?.data?.token ?? "",
                  secretAccessKey: tokenData?.data?.key ?? "",
                  region: "eu-west-2",
                },
              };

              AWS.config.update(config.aws_remote_config);
              const docClient = new AWS.DynamoDB.DocumentClient();

              const openingHours = val.days.map((x) => {
                return {
                  timings: x.timings,
                  day: x.day,
                  open: x.active,
                  ocTimings: `${x.start_time}-${x.end_time}`,
                };
              });
              let prevInfo = val.oldInfo ?? {};

              prevInfo.ocAgeMax = val.max_age ? parseInt(val.max_age) : 0;
              prevInfo.ocAgeMin = val.min_age ? parseInt(val.min_age) : 0;
              prevInfo.ocEmail = val.email ? val.email : "";
              prevInfo.ocEnabled = val.online_consultation ? true : false;
              prevInfo.ocEnabledChildren = val.online_consultation
                ? true
                : false;
              prevInfo.ocSuccessText = val.message ? val.message : "";
              prevInfo.openingHours = openingHours;

              const params = {
                TableName: config.aws_table_name,
                Key: {
                  nacsCode: val.nacsCode,
                },
                UpdateExpression: "set info = :info",
                ExpressionAttributeValues: {
                  ":info": prevInfo,
                },
              };

              docClient.update(params, async function (err) {
                if (err) {
                  Swal.fire(
                    thisScope.topbarControls.config.updateErrorTitle,
                    thisScope.topbarControls.config.updateErrorMessage,
                    "error"
                  );
                  console.log(err);
                } else {
                  let updatedCat = thisScope.currentCategory;
                  updatedCat.additionalProp1.days = val.days;
                  updatedCat.additionalProp1.message = val.message;
                  updatedCat.additionalProp1.email = val.email;
                  updatedCat.additionalProp1.max_age = val.max_age;
                  updatedCat.additionalProp1.min_age = val.min_age;
                  updatedCat.additionalProp1.online_consultation =
                    val.online_consultation;
                  await categoryService.patch(updatedCat.id, updatedCat);
                  Swal.fire(
                    thisScope.topbarControls.config.updateSuccessTitle,
                    thisScope.topbarControls.config.updateSuccessMessage,
                    "success"
                  );
                }
              });

              Swal.fire(
                thisScope.topbarControls.config.updateSuccessTitle,
                thisScope.topbarControls.config.updateSuccessMessage,
                "success"
              );
            } else {
              var data = JSON.stringify(val);

              for (const key of Object.keys(val)) {
                if (form[key] && form[key].inside) {
                  let inside = form[key].inside;
                  let temp = JSON.parse(data);
                  _.set(temp, inside, val[key]);
                  delete temp[key];
                  data = JSON.stringify(temp);
                } else {
                  let temp = JSON.parse(data);
                  if (key in temp.additionalProp1) {
                    temp.additionalProp1[key] = val[key];
                    delete temp[key];
                    data = JSON.stringify(temp);
                  }
                }
              }
              data = JSON.parse(data);
              try {
                if (thisScope.$route.params.categoryName == "socialmedia") {
                  thisScope.updatePatientNews(data.cmsId, data);
                } else if (
                  thisScope.$route.params.categoryName == "patientnews"
                ) {
                  thisScope.updateSocialMedia(data.cmsId, data);
                }

                await sleep(1);
                await categoryService.patch(data.id, data);
                thisScope.setSelectedItems(val);
                Swal.fire(
                  thisScope.topbarControls.config.updateSuccessTitle,
                  thisScope.topbarControls.config.updateSuccessMessage,
                  "success"
                );
              } catch (err) {
                Swal.fire(
                  thisScope.topbarControls.config.updateErrorTitle,
                  thisScope.topbarControls.config.updateErrorMessage,
                  "error"
                );
                console.log(err);
              }
            }
          };
          this.topbarControls.onSubmitFn = submitFn;
          break;
        }
        case "categoryGroups": {
          const submitFn = async function (val, form) {
            var data = {
              title: val.title,
              text: val.text || "",
            };
            let objIndex = thisScope.topbarControls.listItems.findIndex(
              (obj) => obj.id == thisScope.topbarControls.selectedItem.id
            );
            Object.assign(thisScope.topbarControls.listItems[objIndex], data);

            thisScope.topbarControls.listItems[objIndex];
            let group = thisScope.topbarControls.listItems.filter(
              (x) => x.id == val.id
            )[0];
            Object.assign(group, data);

            let category = thisScope.topbarControls.category;
            category.additionalProp1.groups =
              thisScope.topbarControls.listItems;
            try {
              await categoryService.patch(category.id, category);
              Swal.fire(
                thisScope.topbarControls.config.updateSuccessTitle,
                thisScope.topbarControls.config.updateSuccessMessage,
                "success"
              );
              thisScope.$router.go(thisScope.$router.currentRoute);
            } catch (err) {
              Swal.fire(
                thisScope.topbarControls.config.updateErrorTitle,
                thisScope.topbarControls.config.updateErrorMessage,
                "error"
              );
              console.log(err, form);
            }
          };
          const addFn = async function (val) {
            var data = {
              id: uuidv4(),
              title: val.title,
              text: val.text || "",
              active: true,
              subgroups: [],
            };

            let category = thisScope.topbarControls.category;
            category.additionalProp1.groups.push(data);
            try {
              await categoryService.patch(category.id, category);
              thisScope.setSelectedItems(data);
              Swal.fire(
                thisScope.topbarControls.config.addNewSuccessTitle,
                thisScope.topbarControls.config.addNewSuccessMessage,
                "success"
              );
              // thisScope.$router.go(thisScope.$router.currentRoute);
            } catch (err) {
              Swal.fire(
                thisScope.topbarControls.config.addNewErrorTitle,
                thisScope.topbarControls.config.addNewErrorMessage,
                "error"
              );
              console.log(err);
            }
          };
          const deleteFn = function () {
            let item = thisScope.topbarControls.selectedItem;
            Swal.fire({
              title: `Are you sure you want to delete ${item.title}?`,
              text: "You won't be able to revert this!",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: "Yes, delete it!",
            }).then(async (result) => {
              if (result.value) {
                try {
                  let category = thisScope.topbarControls.category;
                  let filteredList = thisScope.topbarControls.listItems.filter(
                    (x) => x.id != item.id
                  );
                  category.additionalProp1.groups = filteredList;

                  await categoryService.patch(category.id, category);

                  Swal.fire(
                    thisScope.topbarControls.config.deleteSuccessTitle,
                    thisScope.topbarControls.config.deleteSuccessMessage,
                    "success"
                  );
                  thisScope.updateDeletedItemList(item.id, false);
                } catch (err) {
                  Swal.fire(
                    thisScope.topbarControls.config.deleteErrorTitle,
                    thisScope.topbarControls.config.deleteErrorMessage,
                    "error"
                  );
                  console.log(err);
                }
              }
            });
          };
          const activeFn = async function (val) {
            if (val && thisScope.topbarControls.config.activeLimit) {
              let activeCount = thisScope.topbarControls.listItems.filter(
                (x) => x.active == true
              ).length;
              if (activeCount >= thisScope.topbarControls.config.activeLimit) {
                Swal.fire(
                  thisScope.topbarControls.config.activeErrorTitle,
                  thisScope.topbarControls.config.activeErrorMessage,
                  "error"
                );
                return;
              }
            }
            try {
              let category = thisScope.topbarControls.category;
              let updatedList = thisScope.topbarControls.listItems;
              let objIndex = thisScope.topbarControls.listItems.findIndex(
                (obj) => obj.id == thisScope.topbarControls.selectedItem.id
              );
              updatedList[objIndex].active = val;
              category.additionalProp1.groups = updatedList;

              let updateData = {
                additionalProp1: category.additionalProp1,
              };
              await categoryService.patch(category.id, updateData);

              const item = thisScope.topbarControls.selectedItem;
              Object.assign(item, { active: val });
              thisScope.setSelectedItems(item);
              if (val) {
                Swal.fire(
                  thisScope.topbarControls.config.activeSuccessTitle,
                  thisScope.topbarControls.config.activeSuccessMessage,
                  "success"
                );
              } else {
                Swal.fire(
                  "Category Inactivated!",
                  "Category Inactivated Successfully! ",
                  "success"
                );
              }
            } catch (err) {
              Swal.fire(
                thisScope.topbarControls.config.activeErrorTitle,
                thisScope.topbarControls.config.activeErrorMessage,
                "error"
              );
              console.log(err);
            }
          };
          const dragUpdateFn = async function (oldList, list) {
            // thisScope.updateListPositions(oldList, list);
            console.log(oldList, list);
            let category = thisScope.topbarControls.category;
            category.additionalProp1.groups = list;
            try {
              await categoryService.patch(category.id, category);
            } catch (err) {
              console.log(err);
            }
            thisScope.setTopbarControls(null, list, null, null, null);
          };
          const switchItemFn = async function (val) {
            console.log("change5");

            const prev = JSON.parse(thisScope.topbarControls.prevSelectedItem);
            const curr = thisScope.topbarControls.selectedItem;

            if (thisScope.isItemEqual(prev, curr)) {
              thisScope.setTopbarControls(
                null,
                null,
                val,
                JSON.stringify(val),
                null
              );
              // thisScope.setSelectedItems(val)
            } else {
              const { isConfirmed } = await Swal.fire({
                title: "You have unsaved changes.",
                text: "Please save your changes before switching to next topic.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Discard changes",
              });
              if (isConfirmed) {
                thisScope.setTopbarControls(
                  null,
                  null,
                  val,
                  JSON.stringify(val),
                  null
                );
                // thisScope.setSelectedItems(val)
              }
            }
          };
          this.topbarControls.onDelFn = deleteFn;
          this.topbarControls.onAddFn = addFn;
          this.topbarControls.onActiveFn = activeFn;
          this.topbarControls.onDragUpdateFn = dragUpdateFn;
          this.topbarControls.onSwitchItemFn = switchItemFn;
          this.topbarControls.onSubmitFn = submitFn;

          break;
        }
        case "categoryTypes": {
          const submitFn = async function (val, form) {
            var data = {
              title: val.title,
              content: val.content,
            };
            let objIndex = thisScope.topbarControls.listItems.findIndex(
              (obj) => obj.id == thisScope.topbarControls.selectedItem.id
            );
            Object.assign(thisScope.topbarControls.listItems[objIndex], data);

            thisScope.topbarControls.listItems[objIndex];
            let type = thisScope.topbarControls.listItems.filter(
              (x) => x.id == val.id
            )[0];
            Object.assign(type, data);

            let category = thisScope.topbarControls.category;
            category.additionalProp1.types = thisScope.topbarControls.listItems;
            try {
              await categoryService.patch(category.id, category);
              //update prev value
              if (thisScope.topbarControls?.selectedItem?.form_layout) {
                thisScope.topbarControls.prevSelectedItem = JSON.stringify(
                  thisScope.topbarControls.selectedItem
                );
              }
              Swal.fire(
                thisScope.topbarControls.config.updateSuccessTitle,
                thisScope.topbarControls.config.updateSuccessMessage,
                "success"
              );
              // thisScope.$router.go(thisScope.$router.currentRoute)
            } catch (err) {
              Swal.fire(
                thisScope.topbarControls.config.updateErrorTitle,
                thisScope.topbarControls.config.updateErrorMessage,
                "error"
              );
              console.log(err, form);
            }
          };
          const addFn = async function (val) {
            var data = {
              id: uuidv4(),
              title: val.title,
              active: true,
              content: "",
            };

            let category = thisScope.topbarControls.category;
            category.additionalProp1.types.push(data);
            try {
              await categoryService.patch(category.id, category);
              thisScope.setSelectedItems(data);
              Swal.fire(
                thisScope.topbarControls.config.addNewSuccessTitle,
                thisScope.topbarControls.config.addNewSuccessMessage,
                "success"
              );
              // thisScope.$router.go(thisScope.$router.currentRoute)
            } catch (err) {
              Swal.fire(
                thisScope.topbarControls.config.addNewErrorTitle,
                thisScope.topbarControls.config.addNewErrorMessage,
                "error"
              );
              console.log(err);
            }
          };
          const deleteFn = function () {
            let item = thisScope.topbarControls.selectedItem;
            Swal.fire({
              title: `Are you sure you want to delete ${item.title}?`,
              text: "You won't be able to revert this!",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: "Yes, delete it!",
            }).then(async (result) => {
              if (result.value) {
                try {
                  let category = thisScope.topbarControls.category;
                  let filteredList = thisScope.topbarControls.listItems.filter(
                    (x) => x.id != item.id
                  );
                  category.additionalProp1.types = filteredList;

                  await categoryService.patch(category.id, category);

                  Swal.fire(
                    thisScope.topbarControls.config.deleteSuccessTitle,
                    thisScope.topbarControls.config.deleteSuccessMessage,
                    "success"
                  );
                  thisScope.updateDeletedItemList(item.id, false);
                } catch (err) {
                  Swal.fire(
                    thisScope.topbarControls.config.deleteErrorTitle,
                    thisScope.topbarControls.config.deleteErrorMessage,
                    "error"
                  );
                  console.log(err);
                }
              }
            });
          };
          const activeFn = async function (val) {
            if (val && thisScope.topbarControls.config.activeLimit) {
              let activeCount = thisScope.topbarControls.listItems.filter(
                (x) => x.active == true
              ).length;
              if (activeCount >= thisScope.topbarControls.config.activeLimit) {
                Swal.fire(
                  thisScope.topbarControls.config.activeErrorTitle,
                  thisScope.topbarControls.config.activeErrorMessage,
                  "error"
                );
                return;
              }
            }
            try {
              let category = thisScope.topbarControls.category;
              let updatedList = thisScope.topbarControls.listItems;
              let objIndex = thisScope.topbarControls.listItems.findIndex(
                (obj) => obj.id == thisScope.topbarControls.selectedItem.id
              );
              updatedList[objIndex].active = val;
              category.additionalProp1.types = updatedList;

              let updateData = {
                additionalProp1: category.additionalProp1,
              };
              await categoryService.patch(category.id, updateData);

              const item = thisScope.topbarControls.selectedItem;
              Object.assign(item, { active: val });
              thisScope.setSelectedItems(item);
              if (val) {
                Swal.fire(
                  thisScope.topbarControls.config.activeSuccessTitle,
                  thisScope.topbarControls.config.activeSuccessMessage,
                  "success"
                );
              } else {
                Swal.fire(
                  "Type Inactivated!",
                  "Type Inactivated Successfully! ",
                  "success"
                );
              }
            } catch (err) {
              Swal.fire(
                thisScope.topbarControls.config.activeErrorTitle,
                thisScope.topbarControls.config.activeErrorMessage,
                "error"
              );
              console.log(err);
            }
          };
          const dragUpdateFn = async function (oldList, list) {
            // thisScope.updateListPositions(oldList, list);
            let category = thisScope.topbarControls.category;
            category.additionalProp1.types = list;
            // for Prescriptions category the options and types messed up so handling this code for reorder issue
            if (category.name === "Prescriptions") {
              category.additionalProp1.options = list;
            }
            try {
              await categoryService.patch(category.id, category);
            } catch (err) {
              console.log(err);
            }
            thisScope.setTopbarControls(null, list, null, null, null);
          };
          const switchItemFn = async function (val) {
            console.log("change1");
            const prev = JSON.parse(thisScope.topbarControls.prevSelectedItem);
            const curr = thisScope.topbarControls.selectedItem;

            if (thisScope.isItemEqual(prev, curr)) {
              thisScope.setTopbarControls(
                null,
                null,
                val,
                JSON.stringify(val),
                null
              );
              // thisScope.setSelectedItems(val)
            } else {
              const { isConfirmed } = await Swal.fire({
                title: "You have unsaved changes.",
                text: "Please save your changes before switching to next topic.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Discard changes",
              });
              if (isConfirmed) {
                thisScope.setTopbarControls(
                  null,
                  null,
                  val,
                  JSON.stringify(val),
                  null
                );
                // thisScope.setSelectedItems(val)
              }
            }
          };
          this.topbarControls.onDelFn = deleteFn;
          this.topbarControls.onAddFn = addFn;
          this.topbarControls.onActiveFn = activeFn;
          this.topbarControls.onDragUpdateFn = dragUpdateFn;
          this.topbarControls.onSwitchItemFn = switchItemFn;
          this.topbarControls.onSubmitFn = submitFn;

          break;
        }
        case "categoryOptions": {
          const submitFn = async function (val, form) {
            var data = {
              title: val.title,
              description: val.description,
              nhs_app: val.nhs_app,
              patient_access: val.patient_access,
              systm_online: val.systm_online,
              contact_us: val.contact_us,
            };
            let objIndex = thisScope.topbarControls.listItems.findIndex(
              (obj) => obj.id == thisScope.topbarControls.selectedItem.id
            );
            Object.assign(thisScope.topbarControls.listItems[objIndex], data);

            thisScope.topbarControls.listItems[objIndex];
            let type = thisScope.topbarControls.listItems.filter(
              (x) => x.id == val.id
            )[0];
            Object.assign(type, data);

            let category = thisScope.topbarControls.category;
            category.additionalProp1.options =
              thisScope.topbarControls.listItems;
            try {
              await categoryService.patch(category.id, category);
              if (thisScope.topbarControls?.selectedItem?.form_layout) {
                thisScope.topbarControls.prevSelectedItem = JSON.stringify(
                  thisScope.topbarControls.selectedItem
                );
              }
              Swal.fire(
                thisScope.topbarControls.config.updateSuccessTitle,
                thisScope.topbarControls.config.updateSuccessMessage,
                "success"
              );
              // thisScope.$router.go(thisScope.$router.currentRoute)
            } catch (err) {
              Swal.fire(
                thisScope.topbarControls.config.updateErrorTitle,
                thisScope.topbarControls.config.updateErrorMessage,
                "error"
              );
              console.log(err, form);
            }
          };
          const addFn = async function (val) {
            var data = {
              id: uuidv4(),
              title: val.title,
              active: true,
              description: "",
              nhs_app: false,
              patient_access: false,
              systm_online: false,
              contact_us: false,
            };

            let category = thisScope.topbarControls.category;
            category.additionalProp1.options.push(data);
            try {
              await categoryService.patch(category.id, category);
              thisScope.setSelectedItems(data);
              Swal.fire(
                thisScope.topbarControls.config.addNewSuccessTitle,
                thisScope.topbarControls.config.addNewSuccessMessage,
                "success"
              );
              // thisScope.$router.go(thisScope.$router.currentRoute)
            } catch (err) {
              Swal.fire(
                thisScope.topbarControls.config.addNewErrorTitle,
                thisScope.topbarControls.config.addNewErrorMessage,
                "error"
              );
              console.log(err);
            }
          };
          const deleteFn = function () {
            let item = thisScope.topbarControls.selectedItem;
            Swal.fire({
              title: `Are you sure you want to delete ${item.title}?`,
              text: "You won't be able to revert this!",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: "Yes, delete it!",
            }).then(async (result) => {
              if (result.value) {
                try {
                  let category = thisScope.topbarControls.category;
                  let filteredList = thisScope.topbarControls.listItems.filter(
                    (x) => x.id != item.id
                  );
                  category.additionalProp1.options = filteredList;

                  await categoryService.patch(category.id, category);

                  Swal.fire(
                    thisScope.topbarControls.config.deleteSuccessTitle,
                    thisScope.topbarControls.config.deleteSuccessMessage,
                    "success"
                  );
                  thisScope.updateDeletedItemList(item.id, false);
                } catch (err) {
                  Swal.fire(
                    thisScope.topbarControls.config.deleteErrorTitle,
                    thisScope.topbarControls.config.deleteErrorMessage,
                    "error"
                  );
                  console.log(err);
                }
              }
            });
          };
          const activeFn = async function (val) {
            if (val && thisScope.topbarControls.config.activeLimit) {
              let activeCount = thisScope.topbarControls.listItems.filter(
                (x) => x.active == true
              ).length;
              if (activeCount >= thisScope.topbarControls.config.activeLimit) {
                Swal.fire(
                  thisScope.topbarControls.config.activeErrorTitle,
                  thisScope.topbarControls.config.activeErrorMessage,
                  "error"
                );
                return;
              }
            }
            try {
              let category = thisScope.topbarControls.category;
              let updatedList = thisScope.topbarControls.listItems;
              let objIndex = thisScope.topbarControls.listItems.findIndex(
                (obj) => obj.id == thisScope.topbarControls.selectedItem.id
              );
              // This code will be moved to a custom rule function later
              if (category?.name === "Join the Practice") {
                const { additionalProp1 } = category;

                if (additionalProp1?.options?.length > 0) {
                  const title = additionalProp1.options[0]?.title;
                  const selectedItem = thisScope.topbarControls.selectedItem;

                  const proofId = additionalProp1.options.findIndex(
                    (rt) => rt.title === "Proof of ID and Address"
                  );
                  const onlineaccess = additionalProp1.options.findIndex(
                    (rt) => rt.title === "Online Access"
                  );

                  console.log("proofId", proofId, onlineaccess);

                  if (
                    onlineaccess > -1 &&
                    proofId > -1 &&
                    proofId < onlineaccess
                  ) {
                    Swal.fire(
                      "Error",
                      `Online Access should be listed first, followed by Proof of ID and Address.`,
                      "error"
                    );
                    return;
                  }

                  if (title) {
                    if (title !== "Patient’s Details") {
                      Swal.fire(
                        "Error",
                        "Patient Details must be the first section on the form.",
                        "error"
                      );
                      return;
                    }

                    if (
                      selectedItem.title === "Patient’s Details" &&
                      val === false
                    ) {
                      updatedList[objIndex].active = true;
                      Swal.fire(
                        "Error",
                        "Patient Details cannot be deactivated.",
                        "error"
                      );
                      return;
                    }
                    const carersIndex = additionalProp1.options.findIndex(
                      (rt) => rt.title === "Carers"
                    );

                    const kinIndex = additionalProp1.options.findIndex(
                      (rt) => rt.title === "Next of Kin"
                    );
                    if (carersIndex > -1) {
                      const carerNext =
                        additionalProp1.options[carersIndex + 1];
                      if (carerNext.title !== "Next of Kin") {
                        Swal.fire(
                          "Error",
                          "Carers should be listed first, followed by Next of Kin.",
                          "error"
                        );
                        return;
                      }
                    }

                    // active of both the carers and next of kin should be the same
                    if (
                      selectedItem.title === "Carers" ||
                      selectedItem.title === "Next of Kin"
                    ) {
                      additionalProp1.options[carersIndex].active = val;
                      additionalProp1.options[kinIndex].active = val;

                      console.log("logic applie", updatedList);
                    }
                  }
                }
              }
              updatedList[objIndex].active = val;
              category.additionalProp1.options = updatedList;

              let updateData = {
                additionalProp1: category.additionalProp1,
              };
              await categoryService.patch(category.id, updateData);

              const item = thisScope.topbarControls.selectedItem;
              Object.assign(item, { active: val });
              thisScope.setSelectedItems(item);
              if (val) {
                Swal.fire(
                  thisScope.topbarControls.config.activeSuccessTitle,
                  thisScope.topbarControls.config.activeSuccessMessage,
                  "success"
                );
              } else {
                Swal.fire(
                  "Type Inactivated!",
                  "Type Inactivated Successfully! ",
                  "success"
                );
              }
            } catch (err) {
              Swal.fire(
                thisScope.topbarControls.config.activeErrorTitle,
                thisScope.topbarControls.config.activeErrorMessage,
                "error"
              );
              console.log(err);
            }
          };
          const dragUpdateFn = async function (oldList, list) {
            // thisScope.updateListPositions(oldList, list);
            console.log(oldList, list);
            let category = thisScope.topbarControls.category;
            // This code will be moved to a custom rule function later
            if (category?.name === "Join the Practice") {
              const { additionalProp1 } = category;

              if (additionalProp1?.options?.length > 0) {
                const title = list[0]?.title;
                const activeval = list[0]?.active;

                const carersIndex = list.findIndex(
                  (rt) => rt.title === "Carers"
                );

                const proofId = list.findIndex(
                  (rt) => rt.title === "Proof of ID and Address"
                );
                const onlineaccess = list.findIndex(
                  (rt) => rt.title === "Online Access"
                );
                console.log("proofId", proofId, onlineaccess);

                if (
                  onlineaccess > -1 &&
                  proofId > -1 &&
                  proofId < onlineaccess
                ) {
                  Swal.fire(
                    "Error",
                    `Online Access should be listed first, followed by Proof of ID and Address.`,
                    "error"
                  );
                  return;
                }

                if (title) {
                  if (title !== "Patient’s Details") {
                    Swal.fire(
                      "Error",
                      "Patient Details must be the first section on the form.",
                      "error"
                    );
                    return;
                  }

                  if (title === "Patient’s Details" && activeval === false) {
                    Swal.fire(
                      "Error",
                      "Patient Details cannot be deactivated.",
                      "error"
                    );
                    return;
                  }

                  if (carersIndex > -1) {
                    const carerNext = list[carersIndex + 1];
                    if (carerNext.title !== "Next of Kin") {
                      Swal.fire(
                        "Error",
                        "Carers should be listed first, followed by Next of Kin.",
                        "error"
                      );
                      return;
                    }
                  }
                }
              }
            }
            category.additionalProp1.options = list;
            try {
              await categoryService.patch(category.id, category);
            } catch (err) {
              console.log(err);
            }
            thisScope.setTopbarControls(null, list, null, null, null);
          };
          const switchItemFn = async function (val) {
            console.log("change2");

            const prev = JSON.parse(thisScope.topbarControls.prevSelectedItem);
            const curr = thisScope.topbarControls.selectedItem;

            if (thisScope.isItemEqual(prev, curr)) {
              thisScope.setTopbarControls(
                null,
                null,
                val,
                JSON.stringify(val),
                null
              );
              // thisScope.setSelectedItems(val)
            } else {
              const { isConfirmed } = await Swal.fire({
                title: "You have unsaved changes.",
                text: "Please save your changes before switching to next topic.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Discard changes",
              });
              if (isConfirmed) {
                thisScope.setTopbarControls(
                  null,
                  null,
                  val,
                  JSON.stringify(val),
                  null
                );
                // thisScope.setSelectedItems(val)
              }
            }
          };
          this.topbarControls.onDelFn = deleteFn;
          this.topbarControls.onAddFn = addFn;
          this.topbarControls.onActiveFn = activeFn;
          this.topbarControls.onDragUpdateFn = dragUpdateFn;
          this.topbarControls.onSwitchItemFn = switchItemFn;
          this.topbarControls.onSubmitFn = submitFn;

          break;
        }
        case "categoryQuestions": {
          const submitFn = async function (val, form) {
            var data = {
              title: val.title,
              content: val.content,
            };
            let objIndex = thisScope.topbarControls.listItems.findIndex(
              (obj) => obj.id == thisScope.topbarControls.selectedItem.id
            );
            Object.assign(thisScope.topbarControls.listItems[objIndex], data);

            thisScope.topbarControls.listItems[objIndex];
            let question = thisScope.topbarControls.listItems.filter(
              (x) => x.id == val.id
            )[0];
            Object.assign(question, data);

            let category = thisScope.topbarControls.category;
            category.additionalProp1.questions =
              thisScope.topbarControls.listItems;
            try {
              await categoryService.patch(category.id, category);
              Swal.fire(
                thisScope.topbarControls.config.updateSuccessTitle,
                thisScope.topbarControls.config.updateSuccessMessage,
                "success"
              );
              thisScope.$router.go(thisScope.$router.currentRoute);
            } catch (err) {
              Swal.fire(
                thisScope.topbarControls.config.updateErrorTitle,
                thisScope.topbarControls.config.updateErrorMessage,
                "error"
              );
              console.log(err, form);
            }
          };
          const addFn = async function (val) {
            var data = {
              id: uuidv4(),
              title: val.title,
              active: true,
              description: "",
              options: false,
              options_list: [],
              common_ailments: false,
              common_ailments_list: [],
            };

            let category = thisScope.topbarControls.category;
            category.additionalProp1.questions.push(data);
            try {
              await categoryService.patch(category.id, category);
              thisScope.setSelectedItems(data);
              Swal.fire(
                thisScope.topbarControls.config.addNewSuccessTitle,
                thisScope.topbarControls.config.addNewSuccessMessage,
                "success"
              );
              thisScope.$router.go(thisScope.$router.currentRoute);
            } catch (err) {
              Swal.fire(
                thisScope.topbarControls.config.addNewErrorTitle,
                thisScope.topbarControls.config.addNewErrorMessage,
                "error"
              );
              console.log(err);
            }
          };
          const deleteFn = function () {
            let item = thisScope.topbarControls.selectedItem;
            Swal.fire({
              title: `Are you sure you want to delete ${item.title}?`,
              text: "You won't be able to revert this!",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: "Yes, delete it!",
            }).then(async (result) => {
              if (result.value) {
                try {
                  let category = thisScope.topbarControls.category;
                  let filteredList = thisScope.topbarControls.listItems.filter(
                    (x) => x.id != item.id
                  );
                  category.additionalProp1.questions = filteredList;

                  await categoryService.patch(category.id, category);

                  Swal.fire(
                    thisScope.topbarControls.config.deleteSuccessTitle,
                    thisScope.topbarControls.config.deleteSuccessMessage,
                    "success"
                  );
                  thisScope.updateDeletedItemList(item.id, false);
                  thisScope.$router.go(thisScope.$router.currentRoute);
                } catch (err) {
                  Swal.fire(
                    thisScope.topbarControls.config.deleteErrorTitle,
                    thisScope.topbarControls.config.deleteErrorMessage,
                    "error"
                  );
                  console.log(err);
                }
              }
            });
          };
          const activeFn = async function (val) {
            if (val && thisScope.topbarControls.config.activeLimit) {
              let activeCount = thisScope.topbarControls.listItems.filter(
                (x) => x.active == true
              ).length;
              if (activeCount >= thisScope.topbarControls.config.activeLimit) {
                Swal.fire(
                  thisScope.topbarControls.config.activeErrorTitle,
                  thisScope.topbarControls.config.activeErrorMessage,
                  "error"
                );
                return;
              }
            }
            try {
              let category = thisScope.topbarControls.category;
              let updatedList = thisScope.topbarControls.listItems;
              let objIndex = thisScope.topbarControls.listItems.findIndex(
                (obj) => obj.id == thisScope.topbarControls.selectedItem.id
              );
              updatedList[objIndex].active = val;
              category.additionalProp1.questions = updatedList;

              let updateData = {
                additionalProp1: category.additionalProp1,
              };
              await categoryService.patch(category.id, updateData);

              const item = thisScope.topbarControls.selectedItem;
              Object.assign(item, { active: val });
              thisScope.setSelectedItems(item);
              if (val) {
                Swal.fire(
                  thisScope.topbarControls.config.activeSuccessTitle,
                  thisScope.topbarControls.config.activeSuccessMessage,
                  "success"
                );
              } else {
                Swal.fire(
                  "Question Inactivated!",
                  "Question Inactivated Successfully! ",
                  "success"
                );
              }
              thisScope.$router.go(thisScope.$router.currentRoute);
            } catch (err) {
              Swal.fire(
                thisScope.topbarControls.config.activeErrorTitle,
                thisScope.topbarControls.config.activeErrorMessage,
                "error"
              );
              console.log(err);
            }
          };
          const dragUpdateFn = async function (oldList, list) {
            // thisScope.updateListPositions(oldList, list);
            console.log(oldList, list);
            let category = thisScope.topbarControls.category;
            category.additionalProp1.questions = list;
            try {
              await categoryService.patch(category.id, category);
            } catch (err) {
              console.log(err);
            }
            thisScope.setTopbarControls(null, list, null, null, null);
          };
          const switchItemFn = async function (val) {
            console.log("change3");

            const prev = JSON.parse(thisScope.topbarControls.prevSelectedItem);
            const curr = thisScope.topbarControls.selectedItem;

            if (thisScope.isItemEqual(prev, curr)) {
              thisScope.setTopbarControls(
                null,
                null,
                val,
                JSON.stringify(val),
                null
              );
              // thisScope.setSelectedItems(val)
            } else {
              const { isConfirmed } = await Swal.fire({
                title: "You have unsaved changes.",
                text: "Please save your changes before switching to next topic.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Discard changes",
              });
              if (isConfirmed) {
                thisScope.setTopbarControls(
                  null,
                  null,
                  val,
                  JSON.stringify(val),
                  null
                );
                // thisScope.setSelectedItems(val)
              }
            }
          };
          this.topbarControls.onDelFn = deleteFn;
          this.topbarControls.onAddFn = addFn;
          this.topbarControls.onActiveFn = activeFn;
          this.topbarControls.onDragUpdateFn = dragUpdateFn;
          this.topbarControls.onSwitchItemFn = switchItemFn;
          this.topbarControls.onSubmitFn = submitFn;

          break;
        }
        case "categoryFaqs": {
          const submitFn = async function (val, form) {
            var data = {
              title: val.title,
              content: val.content,
            };
            let objIndex = thisScope.topbarControls.listItems.findIndex(
              (obj) => obj.id == thisScope.topbarControls.selectedItem.id
            );
            Object.assign(thisScope.topbarControls.listItems[objIndex], data);

            thisScope.topbarControls.listItems[objIndex];
            let question = thisScope.topbarControls.listItems.filter(
              (x) => x.id == val.id
            )[0];
            Object.assign(question, data);

            let category = thisScope.topbarControls.category;
            category.additionalProp1.questions =
              thisScope.topbarControls.listItems;
            try {
              await categoryService.patch(category.id, category);
              Swal.fire(
                thisScope.topbarControls.config.updateSuccessTitle,
                thisScope.topbarControls.config.updateSuccessMessage,
                "success"
              );
              //  thisScope.$router.go(thisScope.$router.currentRoute);
            } catch (err) {
              Swal.fire(
                thisScope.topbarControls.config.updateErrorTitle,
                thisScope.topbarControls.config.updateErrorMessage,
                "error"
              );
              console.log(err, form);
            }
          };
          const addFn = async function (val) {
            var data = {
              id: uuidv4(),
              title: val.title,
              active: true,
              answer: val.answer || "",
            };

            let category = thisScope.topbarControls.category;
            category.additionalProp1.questions.push(data);
            try {
              await categoryService.patch(category.id, category);
              thisScope.setSelectedItems(data);
              Swal.fire(
                thisScope.topbarControls.config.addNewSuccessTitle,
                thisScope.topbarControls.config.addNewSuccessMessage,
                "success"
              );
              // thisScope.$router.go(thisScope.$router.currentRoute);
            } catch (err) {
              Swal.fire(
                thisScope.topbarControls.config.addNewErrorTitle,
                thisScope.topbarControls.config.addNewErrorMessage,
                "error"
              );
              console.log(err);
            }
          };
          const deleteFn = function () {
            let item = thisScope.topbarControls.selectedItem;
            Swal.fire({
              title: `Are you sure you want to delete ${item.title}?`,
              text: "You won't be able to revert this!",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: "Yes, delete it!",
            }).then(async (result) => {
              if (result.value) {
                try {
                  let category = thisScope.topbarControls.category;
                  let filteredList = thisScope.topbarControls.listItems.filter(
                    (x) => x.id != item.id
                  );
                  category.additionalProp1.questions = filteredList;

                  await categoryService.patch(category.id, category);

                  Swal.fire(
                    thisScope.topbarControls.config.deleteSuccessTitle,
                    thisScope.topbarControls.config.deleteSuccessMessage,
                    "success"
                  );
                  thisScope.updateDeletedItemList(item.id, false);
                  //  thisScope.$router.go(thisScope.$router.currentRoute);
                } catch (err) {
                  Swal.fire(
                    thisScope.topbarControls.config.deleteErrorTitle,
                    thisScope.topbarControls.config.deleteErrorMessage,
                    "error"
                  );
                  console.log(err);
                }
              }
            });
          };
          const activeFn = async function (val) {
            if (val && thisScope.topbarControls.config.activeLimit) {
              let activeCount = thisScope.topbarControls.listItems.filter(
                (x) => x.active == true
              ).length;
              if (activeCount >= thisScope.topbarControls.config.activeLimit) {
                Swal.fire(
                  thisScope.topbarControls.config.activeErrorTitle,
                  thisScope.topbarControls.config.activeErrorMessage,
                  "error"
                );
                return;
              }
            }
            try {
              let category = thisScope.topbarControls.category;
              let updatedList = thisScope.topbarControls.listItems;
              let objIndex = thisScope.topbarControls.listItems.findIndex(
                (obj) => obj.id == thisScope.topbarControls.selectedItem.id
              );
              updatedList[objIndex].active = val;
              category.additionalProp1.questions = updatedList;

              let updateData = {
                additionalProp1: category.additionalProp1,
              };
              await categoryService.patch(category.id, updateData);

              const item = thisScope.topbarControls.selectedItem;
              Object.assign(item, { active: val });
              thisScope.setSelectedItems(item);
              if (val) {
                Swal.fire(
                  thisScope.topbarControls.config.activeSuccessTitle,
                  thisScope.topbarControls.config.activeSuccessMessage,
                  "success"
                );
              } else {
                Swal.fire(
                  "Topic Inactivated!",
                  "Topic Inactivated Successfully! ",
                  "success"
                );
              }
              //  thisScope.$router.go(thisScope.$router.currentRoute);
            } catch (err) {
              Swal.fire(
                thisScope.topbarControls.config.activeErrorTitle,
                thisScope.topbarControls.config.activeErrorMessage,
                "error"
              );
              console.log(err);
            }
          };
          const dragUpdateFn = async function (oldList, list) {
            // thisScope.updateListPositions(oldList, list);
            console.log(oldList, list);
            let category = thisScope.topbarControls.category;
            category.additionalProp1.questions = list;
            try {
              await categoryService.patch(category.id, category);
            } catch (err) {
              console.log(err);
            }
            thisScope.setTopbarControls(null, list, null, null, null);
          };
          const switchItemFn = async function (val) {
            const prev = JSON.parse(thisScope.topbarControls.prevSelectedItem);
            const curr = thisScope.topbarControls.selectedItem;

            if (thisScope.isItemEqual(prev, curr)) {
              thisScope.setTopbarControls(
                null,
                null,
                val,
                JSON.stringify(val),
                null
              );
              // thisScope.setSelectedItems(val)
            } else {
              const { isConfirmed } = await Swal.fire({
                title: "You have unsaved changes.",
                text: "Please save your changes before switching to next topic.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Discard changes",
              });
              if (isConfirmed) {
                thisScope.setTopbarControls(
                  null,
                  null,
                  val,
                  JSON.stringify(val),
                  null
                );
                // thisScope.setSelectedItems(val)
              }
            }
          };
          this.topbarControls.onDelFn = deleteFn;
          this.topbarControls.onAddFn = addFn;
          this.topbarControls.onActiveFn = activeFn;
          this.topbarControls.onDragUpdateFn = dragUpdateFn;
          this.topbarControls.onSwitchItemFn = switchItemFn;
          this.topbarControls.onSubmitFn = submitFn;

          break;
        }
        case "categoryHelpusList": {
          const submitFn = async function (val, form) {
            var data = {
              title: val.title,
              description: val.description,
              active: val.active,
              info_box: val.info_box,
              info_title: val.info_title,
              info_description: val.info_description,
            };
            let objIndex = thisScope.topbarControls.listItems.findIndex(
              (obj) => obj.id == thisScope.topbarControls.selectedItem.id
            );
            Object.assign(thisScope.topbarControls.listItems[objIndex], data);

            thisScope.topbarControls.listItems[objIndex];
            let helpusItem = thisScope.topbarControls.listItems.filter(
              (x) => x.id == val.id
            )[0];
            Object.assign(helpusItem, data);

            let category = thisScope.topbarControls.category;
            category.additionalProp1.helpus_list =
              thisScope.topbarControls.listItems;
            try {
              await categoryService.patch(category.id, category);
              Swal.fire(
                thisScope.topbarControls.config.updateSuccessTitle,
                thisScope.topbarControls.config.updateSuccessMessage,
                "success"
              );
            } catch (err) {
              Swal.fire(
                thisScope.topbarControls.config.updateErrorTitle,
                thisScope.topbarControls.config.updateErrorMessage,
                "error"
              );
              console.log(err, form);
            }
          };

          const addFn = async function (val) {
            var data = {
              id: uuidv4(),
              title: val.title,
              active: true,
              description: "",
              info_box: false,
              info_title: "",
              info_description: "",
            };

            let category = thisScope.topbarControls.category;
            if (!category.additionalProp1.helpus_list) {
              category.additionalProp1.helpus_list = [];
            }

            // First add to UI list via createdItem (this handles proper ordering)
            thisScope.createdItem(data);

            // Then update backend with the current UI state
            category.additionalProp1.helpus_list =
              thisScope.topbarControls.listItems;

            try {
              await categoryService.patch(category.id, category);
              Swal.fire(
                thisScope.topbarControls.config.addNewSuccessTitle,
                thisScope.topbarControls.config.addNewSuccessMessage,
                "success"
              );
            } catch (err) {
              // If API fails, remove the item from UI list
              thisScope.topbarControls.listItems =
                thisScope.topbarControls.listItems.filter(
                  (item) => item.id !== data.id
                );
              thisScope.setTopbarControls(
                null,
                thisScope.topbarControls.listItems,
                null,
                null,
                null
              );
              Swal.fire(
                thisScope.topbarControls.config.addNewErrorTitle,
                thisScope.topbarControls.config.addNewErrorMessage,
                "error"
              );
              console.log(err);
            }
          };

          const deleteFn = function () {
            let item = thisScope.topbarControls.selectedItem;
            Swal.fire({
              title: `Are you sure you want to delete ${item.title}?`,
              text: "You won't be able to revert this!",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: "Yes, delete it!",
            }).then(async (result) => {
              if (result.value) {
                try {
                  let category = thisScope.topbarControls.category;
                  let filteredList = thisScope.topbarControls.listItems.filter(
                    (x) => x.id != item.id
                  );
                  category.additionalProp1.helpus_list = filteredList;

                  await categoryService.patch(category.id, category);

                  Swal.fire(
                    thisScope.topbarControls.config.deleteSuccessTitle,
                    thisScope.topbarControls.config.deleteSuccessMessage,
                    "success"
                  );
                  thisScope.updateDeletedItemList(item.id, false);
                } catch (err) {
                  Swal.fire(
                    thisScope.topbarControls.config.deleteErrorTitle,
                    thisScope.topbarControls.config.deleteErrorMessage,
                    "error"
                  );
                  console.log(err);
                }
              }
            });
          };

          const activeFn = async function (val) {
            if (val && thisScope.topbarControls.config.activeLimit) {
              let activeCount = thisScope.topbarControls.listItems.filter(
                (x) => x.active == true
              ).length;
              if (activeCount >= thisScope.topbarControls.config.activeLimit) {
                Swal.fire(
                  thisScope.topbarControls.config.activeErrorTitle,
                  thisScope.topbarControls.config.activeErrorMessage,
                  "error"
                );
                return;
              }
            }
            try {
              let category = thisScope.topbarControls.category;
              let updatedList = thisScope.topbarControls.listItems;
              let objIndex = thisScope.topbarControls.listItems.findIndex(
                (obj) => obj.id == thisScope.topbarControls.selectedItem.id
              );
              updatedList[objIndex].active = val;
              category.additionalProp1.helpus_list = updatedList;

              let updateData = {
                additionalProp1: category.additionalProp1,
              };
              await categoryService.patch(category.id, updateData);
              thisScope.setTopbarControls(
                null,
                thisScope.topbarControls.listItems,
                null,
                null,
                null
              );
            } catch (err) {
              console.log(err);
            }
          };

          const dragUpdateFn = async function (oldList, list) {
            let category = thisScope.topbarControls.category;
            category.additionalProp1.helpus_list = list;
            try {
              await categoryService.patch(category.id, category);
            } catch (err) {
              console.log(err);
            }
            thisScope.setTopbarControls(null, list, null, null, null);
          };

          const switchItemFn = async function (val) {
            const prev = JSON.parse(thisScope.topbarControls.prevSelectedItem);
            const curr = thisScope.topbarControls.selectedItem;

            if (thisScope.isItemEqual(prev, curr)) {
              thisScope.setTopbarControls(
                null,
                null,
                val,
                JSON.stringify(val),
                null
              );
            } else {
              const { isConfirmed } = await Swal.fire({
                title: "You have unsaved changes.",
                text: "Please save your changes before switching to next topic.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Discard changes",
              });
              if (isConfirmed) {
                thisScope.setTopbarControls(
                  null,
                  null,
                  val,
                  JSON.stringify(val),
                  null
                );
              }
            }
          };

          this.topbarControls.onDelFn = deleteFn;
          this.topbarControls.onAddFn = addFn;
          this.topbarControls.onActiveFn = activeFn;
          this.topbarControls.onDragUpdateFn = dragUpdateFn;
          this.topbarControls.onSwitchItemFn = switchItemFn;
          this.topbarControls.onSubmitFn = submitFn;

          break;
        }
        case "locationHours": {
          const submitFn = async function (val, form) {
            let curr_loc = thisScope.topbarControls.listItems.filter(
              (x) => x.id == val.location_id
            )[0];
            let temp_re = curr_loc.additionalProp1.regular_hours;

            const elementsIndex = temp_re.findIndex(
              (element) => element.id == val.id
            );
            temp_re[elementsIndex] = val;

            Object.assign(curr_loc.additionalProp1.regular_hours, temp_re);

            try {
              await pageService.patch(curr_loc.id, curr_loc);

              let temp_li = thisScope.topbarControls.listItems;
              const indx = temp_li.findIndex(
                (element) => element.id == curr_loc.id
              );
              temp_li[indx] = curr_loc;
              thisScope.setTopbarControls(null, temp_li, null, null, null);

              Swal.fire(
                thisScope.topbarControls.config.updateSuccessTitle,
                thisScope.topbarControls.config.updateSuccessMessage,
                "success"
              );
            } catch (err) {
              Swal.fire(
                thisScope.topbarControls.config.updateErrorTitle,
                thisScope.topbarControls.config.updateErrorMessage,
                "error"
              );
              console.log(err, form);
            }
          };
          this.topbarControls.onSubmitFn = submitFn;

          break;
        }
      }
    },
  },
};
</script>
<template>
  <Documents v-if="this.$route.params.categoryName == 'documents'" />
  <Layout v-else>
    <UI
      :ui="ui"
      :setTopbarControls="setTopbarControls"
      :topbarControls="topbarControls"
    />
  </Layout>
</template>
